import { useDispatch } from "react-redux";
import { useCalcPriceQuery } from "../../api/queries/priceQueries";
import { useBookingState } from "../../hooks/useBookingState";
import { mappingBookingState2RequestDTO } from "../../mapping/mappingBookingState2RequestDTO";
import { resetBooking } from "../../redux/slices/bookingSlice";
import { splitBookingBasedOnAge } from "../../utils/bookingUtils";
import { PriceDataHelper } from "./PriceDataHelper";

export const useBookingCard = ({
  isEdit = false,
  isUpgrade = false,
  editBookingId,
}: {
  editBookingId?: string;
  isEdit?: boolean;
  isUpgrade?: boolean;
}) => {
  const dispatch = useDispatch();

  const booking = useBookingState({ mode: "FORM" });

  // const pl = (function () {
  //   const invalidAgeProductIds = extractInvalidAgeProductIds(booking);
  //   const childrenLs = (booking.childrenLs ?? []).filter(
  //     (x) => !invalidAgeProductIds.includes(x.product?.id),
  //   );
  //   return [
  //     mappingBookingState2RequestDTO({
  //       ...booking,
  //       childrenLs,
  //     }),
  //   ];
  // })();

  const splitedBookings = splitBookingBasedOnAge(booking);
  const pl =
    splitedBookings?.map((x) => mappingBookingState2RequestDTO(x)) ?? [];
  const bookingPrice = useCalcPriceQuery(pl);
  const updateBookingMode =
    !!editBookingId && (isUpgrade || isEdit) ? true : undefined;

  const bookingPriceNext = useCalcPriceQuery(
    pl,
    {
      params: {
        updateBookingMode,
      },
    },
    !!updateBookingMode,
  );

  // desktop only
  const onReset = () => dispatch(resetBooking());

  const priceDataHelper = new PriceDataHelper(
    splitedBookings,
    bookingPrice.data?.priceOfSingleBookings,
  );

  const priceDataHelperNext = new PriceDataHelper(
    splitedBookings,
    bookingPriceNext.data?.priceOfSingleBookings,
  );

  return {
    booking,
    bookingPrice,
    onReset,
    priceDataHelper,
    priceDataHelperNext,
    isEdit,
    isUpgrade,
  };
};

export type TBookingPriceData = {
  currentBPrice: PriceOfSingleBookingDTO;
  currentBState: BookingState;
};
